import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import BankScopeField from '../../components/BankScopeField';
import ScopeField from '../../components/ScopeField';
import TicketReceiptModal from '../../components/TicketReceiptModal';
import DateField from '../../components/DateField';
import LotteryCodeField from '../../components/LotteryCodeField';
import { searchVerifyTickets } from '../../api/verifyTicket';
import { todayISO } from '../../utils/date';
import './VerifierTicketPage.css';

const VerifierTicketPage = () => {
  const [filterType, setFilterType] = useState('Bank');
  const [scopeId, setScopeId] = useState('');
  const [scopeName, setScopeName] = useState('');
  const [date, setDate] = useState(todayISO());
  const [loterieDe, setLoterieDe] = useState('0');
  const [loterieDeName, setLoterieDeName] = useState('');
  const [loterieUp, setLoterieUp] = useState('0');
  const [loterieUpName, setLoterieUpName] = useState('');
  const [docType, setDocType] = useState('');
  const [ticket, setTicket] = useState('');

  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedTicket, setSelectedTicket] = useState(null);

  const handleFilterChange = (type) => {
    setFilterType(type);
    setScopeId('');
    setScopeName('');
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!scopeId) {
      setError(filterType === 'Group' ? 'Renseigne le group.' : 'Renseigne la banque.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const data = await searchVerifyTickets({
        filterType, scopeId, date, tirageFrom: loterieDe, tirageUp: loterieUp, ticket, docType,
      });
      setResults(data);
      setSearched(true);
    } catch (err) {
      setError('Recherche impossible — verifie que le serveur backend tourne.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <p className="vt-breadcrumb">
        Ruta : <Link to="/dashboard" className="bc-link">Menu</Link>
        {' >> '}
        <Link to="/central" className="bc-link">Central</Link>
        {' >> '}
        <span className="bc-current">Verifier le Ticket</span>
      </p>

      <div className="vt-card">
        <div className="vt-card-header">
          <span className="vt-card-title">Verifiez Ticket</span>
        </div>
        <div className="vt-card-body">
          <form onSubmit={handleSearch} className="vt-form">
            <div className="vt-radio-row">
              {['Bank', 'Group'].map((type) => (
                <label key={type} className="vt-radio-label">
                  <input
                    type="radio"
                    name="searchBy"
                    checked={filterType === type}
                    onChange={() => handleFilterChange(type)}
                  />
                  {type === 'Bank' ? 'Banque' : 'Group'}
                </label>
              ))}
            </div>

            <div className="vt-row">
              <label className="vt-label">{filterType === 'Group' ? 'Group' : 'Banque'}</label>
              {filterType === 'Bank' ? (
                <BankScopeField
                  id={scopeId}
                  name={scopeName}
                  onResolve={(id, nm) => { setScopeId(id); setScopeName(nm); }}
                  inputClass="vt-input vt-input-sm"
                  iconClass="vt-icon-btn"
                  nameClass="vt-bank-name"
                />
              ) : (
                <ScopeField
                  filter={filterType}
                  id={scopeId}
                  name={scopeName}
                  onResolve={(id, nm) => { setScopeId(id); setScopeName(nm); }}
                  inputClass="vt-input vt-input-sm"
                  iconClass="vt-icon-btn"
                  nameClass="vt-bank-name"
                  errClass="vt-bank-name"
                />
              )}
            </div>

            <div className="vt-row">
              <label className="vt-label">De</label>
              <DateField className="vt-input vt-input-date" value={date} onChange={setDate} />
            </div>

            <div className="vt-row">
              <label className="vt-label">Loterie De</label>
              <LotteryCodeField
                value={loterieDe}
                name={loterieDeName}
                onChange={(code) => { setLoterieDe(code); setLoterieDeName(''); }}
                onResolve={(code, nm) => { setLoterieDe(code); setLoterieDeName(nm); }}
                inputClass="vt-input vt-input-sm"
                iconClass="vt-icon-btn"
                nameClass="vt-bank-name"
              />

              <label className="vt-label vt-label-gap">Loterie Up</label>
              <LotteryCodeField
                value={loterieUp}
                name={loterieUpName}
                onChange={(code) => { setLoterieUp(code); setLoterieUpName(''); }}
                onResolve={(code, nm) => { setLoterieUp(code); setLoterieUpName(nm); }}
                inputClass="vt-input vt-input-sm"
                iconClass="vt-icon-btn"
                nameClass="vt-bank-name"
              />
            </div>

            <div className="vt-row">
              <label className="vt-label">Type de document</label>
              <select className="vt-select" value={docType} onChange={(e) => setDocType(e.target.value)}>
                <option value=""></option>
                <option value="Online">En ligne</option>
                <option value="Local">Local</option>
              </select>
            </div>

            <div className="vt-row">
              <label className="vt-label">Ticket</label>
              <input
                className="vt-input vt-input-sm"
                type="text"
                value={ticket}
                onChange={(e) => setTicket(e.target.value)}
              />
            </div>

            <button type="submit" className="vt-search-btn" disabled={loading}>
              {loading ? 'Recherche...' : 'Chercher'}
            </button>

            {error && <p className="vt-error">{error}</p>}
          </form>
        </div>
      </div>

      {searched && (
        <div className="vt-card">
          <div className="vt-card-header">
            <span className="vt-card-title">Listado Tickets</span>
          </div>
          <div className="vt-card-body">
            <table className="vt-table">
              <thead>
                <tr>
                  <th>Ticket</th>
                  <th>Loterie</th>
                  <th>Date</th>
                  <th>Temp</th>
                  <th>Montant</th>
                  <th>Annule?</th>
                </tr>
              </thead>
              <tbody>
                {results.map((row) => {
                  const created = new Date(row.created_at);
                  return (
                    <tr key={row.id} className="vt-row-hover" onClick={() => setSelectedTicket(row)}>
                      <td>{row.no ?? '-'}</td>
                      <td>{row.tirage_name}</td>
                      <td>{created.toLocaleDateString()}</td>
                      <td>{created.toLocaleTimeString()}</td>
                      <td>{Number(row.total_amount).toFixed(2)}</td>
                      <td>{row.is_deleted ? 'Oui' : 'No'}</td>
                    </tr>
                  );
                })}
                {results.length === 0 && (
                  <tr><td colSpan={6} className="vt-empty">Aucun ticket trouvé.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {selectedTicket && (
        <TicketReceiptModal
          ticket={selectedTicket}
          bank={selectedTicket.bank}
          bankName={selectedTicket.bank_name}
          onClose={() => setSelectedTicket(null)}
        />
      )}
    </Layout>
  );
};

export default VerifierTicketPage;
